import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import MovieContext from './context/store';

const Watchtime = ({getdata}) => {

    const context = React.useContext(MovieContext);
    

    const handleChange = (event) => {
        context.handleShowtime(event.target.value);
        getdata();
    }

    

    return (
        <div>
            <h1>Movie or show length</h1>
            <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        onChange={(event) => handleChange(event)}
      >
        <FormControlLabel value="thirty" control={<Radio />} label="30 minutes" />
        <FormControlLabel value="hour" control={<Radio />} label="1 hour" />
        <FormControlLabel value="twohours" control={<Radio />} label="2 hours" />
        <FormControlLabel value="over2" control={<Radio />} label="over 2 hours" />
        
      </RadioGroup>
    </FormControl>
        </div>
    )
}

export default Watchtime;